const isEmailValid = (email = ""): boolean => {
  if (email === "") {
    return true;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export { isEmailValid };
